export default __webpack_public_path__ + "static/media/cases1@2x.c2a8d14c.jpg";